export const HOME = "/";
export const ABOUT = "/about";
export const PORTFOLIO = "/portfolio";
export const CONTACT = "/contact";
